import { translate, filtersFormController, action } from 'magner';
import type { EventGuest } from 'features/events/guests/types/hubstr';
import { downloadGuestsReport } from 'features/events/guests/requests/hubstr';

const eventGuestsFilters = filtersFormController<EventGuest>({
  actions: [{
    type: 'action',
    props: {
      text: translate('hubstr.reports.table.downloadList'),
      type: 'primary',
      class: 'xlsx-download-btn',
    },
    // @ts-ignore
    action: action(async ({ data, router }) => {
      const eventId = router.currentRoute.value.params?.id;
      if (eventId) {
        await downloadGuestsReport({
          ...data,
          eventId,
          format: 'xlsx',
        });
      }
    }),
  }],

  submitEvent: 'input',
  saveToLocalStorage: true,

  pagination: {
    items: 25,
    page: 1,
  },
  filtersInSeparatePanel: false,
  filtersData: {
    firstName: '',
    status: null,
  },
  sort: {},

  layout: [
    {
      type: 'input',
      name: 'firstName',
      props: {
        placeholder: translate('hubstr.event.guests.filters.name'),
        inputDelay: 250,
      },
    },
    {
      type: 'select',
      name: 'status',
      options: [
        {
          value: 'willGo',
          label: translate('hubstr.event.guests.statuses.willGo'),
        },
        {
          value: 'willNotGo',
          label: translate('hubstr.event.guests.statuses.willNotGo'),
        },
        {
          value: 'read',
          label: translate('hubstr.event.guests.statuses.read'),
        },
        {
          value: 'new',
          label: translate('hubstr.event.guests.statuses.new'),
        },
        {
          value: 'noAnswer',
          label: translate('hubstr.event.guests.statuses.noAnswer'),
        },
        {
          value: 'favorite',
          label: translate('hubstr.event.guests.statuses.favorite'),
        },
      ],
      props: {
        placeholder: translate('hubstr.event.guests.filters.status'),
        clearable: true,
      },
    },
  ],
});

export default eventGuestsFilters;
